export const togglePredicate = <T = void>(value: T) => !value;
export const cleanArrayPredicate = <T>(value: T) => Boolean(value);
export const onPreventMouseDown = (
  event: React.MouseEvent<HTMLSpanElement>
) => {
  event.preventDefault();
  event.stopPropagation();
};

export const stringConverterPredicate = <T>(value: T) => String(value);

export const filterUnassigned = <T>(value: T) => value !== "-1";

export const popUpContainerPredicate = (triggerNode: HTMLElement) =>
  triggerNode.parentElement as HTMLElement;
